export default {
  getDashboardCards: (state) => state.dashboardCards,
  getHubCardActive: (state) => state.hubCardActive,
  getAggregatedCardsData: (state, _, __, rootGetters) => {
    const richtlinien = rootGetters['ticket/getRichtlinieSelected'].sort(
      (a, b) => a.value - b.value
    );
    const allRichtlinien = rootGetters['ticket/getRichtlinien']
    const gemeinden = new Set(
      rootGetters['ticket/getGemeindenActive'].map((g) => g.ags)
    );
    const cardsConfig = JSON.parse(JSON.stringify(state.dashboardCards));
    const data = state.dashboardCardsData.filter((e) => gemeinden.has(e.ags));

    const getAmountWithFlag = (...keyTreeArrays) => {
      if (keyTreeArrays.length === 0) throw Error('Empty array');
      if (!Array.isArray(keyTreeArrays[0])) {
        keyTreeArrays = [keyTreeArrays];
      }
      return data.filter((e) => {
        for (let array of keyTreeArrays) {
          let val = JSON.parse(JSON.stringify(e));
          for (let key of array) {
            if (typeof val === 'object' && key in val) {
              val = val[key];
            } else {
              throw Error(`key ${key} does not exist in object ${val}`);
            }
          }
          if (!val) return false;
        }
        return true;
      }).length;
    };

    // Abschluss Vereinbarung
    cardsConfig[1].communityCount = getAmountWithFlag([
      'cooperation_agreement',
      'community_interest_exists',
    ]);
    cardsConfig[1].milestoneGroups[0].milestones = [
      {
        value: getAmountWithFlag(
          ['cooperation_agreement', 'completed'],
          ['cooperation_agreement', 'community_interest_exists']
        ),
        max: cardsConfig[1].communityCount,
      },
    ];
    cardsConfig[1].tooltip = `${cardsConfig[1].communityCount} der ${gemeinden.size} ausgewählten Gemeinden`;

    // MEV
    let maxMev = 0;
    for (let gem of data) {
      for (let rl of richtlinien.map((r) => r.value || r)) {
        if (rl === 2000 || rl === '2000') {
          continue;
        }
        if (gem.mev[`${rl}`].mev_grey_spots_available) {
          maxMev++;
          break;
        }
      }
    }
    for (let rl of richtlinien.map((r) => r.value || r)) {
      if (rl === 2000 || rl === '2000') {
        cardsConfig[2].milestoneGroups[0].milestones.push({value: 0, max: 0})
        cardsConfig[2].milestoneGroups[1].milestones.push({value: 0, max: 0})
        cardsConfig[2].milestoneGroups[2].milestones.push({value: 0, max: 0})
      }
      else {
        const max = getAmountWithFlag(['mev', rl, 'mev_grey_spots_available']);
        // Start
        cardsConfig[2].milestoneGroups[0].milestones.push({
          value: getAmountWithFlag(
            ['mev', rl, 'start_date'],
            ['mev', rl, 'oew_is_executive'],
          ),
          max,
        });
        // Ende
        cardsConfig[2].milestoneGroups[1].milestones.push({
          value: getAmountWithFlag(
            ['mev', rl, 'end_date'],
            ['mev', rl, 'oew_is_executive'],
          ),
          max,
        });
        // Veröffentlichung Ergebnisse
        let published = getAmountWithFlag(
          ['mev', rl, 'publish_date_mev'],
          ['mev', rl, 'oew_is_executive'],
        );
        cardsConfig[2].milestoneGroups[2].milestones.push({
          value: published,
          max,
        });
      }
    }
    cardsConfig[2].communityCount = maxMev;
    cardsConfig[2].tooltip = `${cardsConfig[2].communityCount} der ${gemeinden.size} ausgewählten Gemeinden`;

    // Förderantrag
    let grantApplicationsMax = 0;
    for (let gem of data) {
      for (let rl of richtlinien.map((r) => r.value || r)) {
        if (gem.grant_applications[`${rl}`].federal_application_made) {
          grantApplicationsMax++;
          break;
        }
      }
    }
    for (let rl of richtlinien.map((r) => r.value || r)) {
      let max = getAmountWithFlag([
        'grant_applications',
        rl,
        'federal_application_made',
      ]);
      // Antrag Bund gestellt
      cardsConfig[3].milestoneGroups[0].milestones.push({
        value: getAmountWithFlag([
          'grant_applications',
          rl,
          'federal_application_made',
        ]),
        max,
      });
      // Antrag Land gestellt
      cardsConfig[3].milestoneGroups[1].milestones.push({
        value: getAmountWithFlag([
          'grant_applications',
          rl,
          'state_application_made',
        ]),
        max,
      });
      // Vorläufige Bewilligung Bund
      cardsConfig[3].milestoneGroups[2].milestones.push({
        value: getAmountWithFlag([
          'grant_applications',
          rl,
          'federal_temporary_approval',
        ]),
        max,
      });
      // Vorläufige Bewilligung Land
      cardsConfig[3].milestoneGroups[3].milestones.push({
        value: getAmountWithFlag([
          'grant_applications',
          rl,
          'state_temporary_approval',
        ]),
        max,
      });
      // Endgültige Bewilligung Bund
      // TODO: Progress not defined yet
      cardsConfig[3].milestoneGroups[4].milestones.push({
        value: 0,
        max,
      });
      // Endgültige Bewilligung Land
      // TODO: Progress not defined yet
      cardsConfig[3].milestoneGroups[5].milestones.push({
        value: 0,
        max,
      });
    }
    cardsConfig[3].communityCount = grantApplicationsMax;
    cardsConfig[3].tooltip = `${cardsConfig[3].communityCount} der ${
      maxMev
    } Gemeinden mit Kooperationsvereinbarung und abgeschlossenem MEV`;

    // Ausschreibung Netzbetrieb
    let maxTenders = 0;
    for (let gem of data) {
      for (let rl of [2000, ...allRichtlinien.map((rl) => rl.value)]) {
        if (gem.grant_applications[`${rl}`].federal_application_made) {
          maxTenders++;
          break;
        }
      }
    }
    const maxTendersMainsOperation = getAmountWithFlag([
      'tenders_mains_operation',
      'counts',
    ]);
    // In Vorbereitung
    cardsConfig[4].milestoneGroups[0].milestones = [
      {
        value: getAmountWithFlag(['tenders_mains_operation', 'start_tender_net']),
        max: maxTendersMainsOperation,
      },
    ];
    // Veröffentlicht
    cardsConfig[4].milestoneGroups[1].milestones = [
      {
        value: getAmountWithFlag([
          'tenders_mains_operation',
          'publish_tender_net',
        ]),
        max: maxTendersMainsOperation,
      },
    ];
    // Abgeschlossen
    cardsConfig[4].milestoneGroups[2].milestones = [
      {
        value: getAmountWithFlag([
          'tenders_mains_operation',
          'end_tender_net',
        ]),
        max: maxTendersMainsOperation,
      },
    ];
    cardsConfig[4].communityCount = maxTendersMainsOperation;
    cardsConfig[4].tooltip = `${cardsConfig[4].communityCount} der ${maxTenders} Gemeinden mit vorläufig bewilligtem Förderantrag (unabhängig von der Auswahl 'Förderrichtlinie')`;

    // Ausschreibung Planung
    const maxTendersGeneralContractor = getAmountWithFlag([
      'tenders_planning',
      'counts',
    ]);
    cardsConfig[5].milestoneGroups[0].milestones = [
      {
        value: getAmountWithFlag(['tenders_planning', 'start_tender_planning']),
        max: maxTendersGeneralContractor,
      },
    ];
    cardsConfig[5].milestoneGroups[1].milestones = [
      {
        value: getAmountWithFlag([
          'tenders_planning',
          'publish_tender_planning',
        ]),
        max: maxTendersGeneralContractor,
      },
    ];
    cardsConfig[5].milestoneGroups[2].milestones = [
      {
        value: getAmountWithFlag([
          'tenders_planning',
          'end_tender_planning',
        ]),
        max: maxTendersGeneralContractor,
      },
    ];
    cardsConfig[5].communityCount = maxTendersGeneralContractor;
    cardsConfig[5].tooltip = `${cardsConfig[5].communityCount} der ${maxTenders} Gemeinden mit vorläufig bewilligtem Förderantrag (unabhängig von der Auswahl 'Förderrichtlinie')`;

    // Ausschreibung Planung/Bau
    const maxTendersConstruction = getAmountWithFlag([
      'tenders_construction',
      'counts',
    ]);
    cardsConfig[6].milestoneGroups[0].milestones = [
      {
        value: getAmountWithFlag(['tenders_construction', 'start_tender_construction']),
        max: maxTendersConstruction,
      },
    ];
    cardsConfig[6].milestoneGroups[1].milestones = [
      {
        value: getAmountWithFlag([
          'tenders_construction',
          'publish_tender_construction',
        ]),
        max: maxTendersConstruction,
      },
    ];
    cardsConfig[6].milestoneGroups[2].milestones = [
      {
        value: getAmountWithFlag([
          'tenders_construction',
          'end_tender_construction',
        ]),
        max: maxTendersConstruction,
      },
    ];
    cardsConfig[6].communityCount = maxTendersConstruction;
    cardsConfig[6].tooltip = `${cardsConfig[6].communityCount} der ${maxTenders} Gemeinden mit vorläufig bewilligtem Förderantrag (unabhängig von der Auswahl 'Förderrichtlinie')`;

    // Planung und Bau GÜ
    const maxPlanningConstructionGeneralContractor = cardsConfig[6].milestoneGroups[2].milestones[0].value
    cardsConfig[7].milestoneGroups[0].milestones = [
      {
        value: null,
        // value: getAmountWithFlag([
        //   'planning_construction_general_contractor',
        //   'opening_conversation_past',
        // ]),
        max: maxPlanningConstructionGeneralContractor,
      },
    ];
    cardsConfig[7].milestoneGroups[1].milestones = [
      {
        value: null,
        // value: getAmountWithFlag([
        //   'planning_construction_general_contractor',
        //   'initial_consultation_municipality_past',
        // ]),
        max: maxPlanningConstructionGeneralContractor,
      },
    ];
    cardsConfig[7].milestoneGroups[2].milestones = [
      {
        value: null,
        // value: getAmountWithFlag([
        //   'planning_construction_general_contractor',
        //   'retrieval_date_past',
        // ]),
        max: maxPlanningConstructionGeneralContractor,
      },
    ];
    cardsConfig[7].milestoneGroups[3].milestones = [
      {
        value: null,
        // value: getAmountWithFlag([
        //   'planning_construction_general_contractor',
        //   'start_date_planning_past',
        // ]),
        max: maxPlanningConstructionGeneralContractor,
      },
    ];
    cardsConfig[7].milestoneGroups[4].milestones = [
      {
        value: null,
        // value: getAmountWithFlag([
        //   'planning_construction_general_contractor',
        //   'start_date_construction_past',
        // ]),
        max: maxPlanningConstructionGeneralContractor,
      },
    ];
    cardsConfig[7].milestoneGroups[5].milestones = [
      {
        value: null,
        // value: getAmountWithFlag([
        //   'planning_construction_general_contractor',
        //   'end_date_planning_past',
        // ]),
        max: maxPlanningConstructionGeneralContractor,
      },
    ];
    cardsConfig[7].milestoneGroups[6].milestones = [
      {
        value: null,
        // value: getAmountWithFlag([
        //   'planning_construction_general_contractor',
        //   'end_date_construction_past',
        // ]),
        max: maxPlanningConstructionGeneralContractor,
      },
    ];
    cardsConfig[7].communityCount = maxPlanningConstructionGeneralContractor;
    cardsConfig[7].tooltip = `${cardsConfig[7].communityCount} der ${cardsConfig[6].communityCount} Gemeinden mit abgeschlossenem Auswahlverfahren`;
    cardsConfig[7].disabled = true;
    return cardsConfig;
  },
  getDashboardCardsData: (state) => state.dashboardCardsData,
  getFilteredDashboardCardsData: (state, _, __, rootGetters) => {
    const gemeinden = new Set(
      rootGetters['ticket/getGemeindenActive'].map((g) => g.ags)
    );
    const data = state.dashboardCardsData.filter((e) => gemeinden.has(e.ags));
    return data;
  },
  getPlanningConstructionData: (state) => state.planningConstructionData,
  getSelectedLots: (state) => state.selectedLots,
  getSelectedSections: (state) => state.selectedSections,
  getUsers: (state) => state.users,
  getInvitations: (state) => state.invitations,
  getGemeinden: (state) => state.gemeinden,
  getLandkreise: (state) => state.landkreise,
  getGroups: (state) => state.groups,
  getEmailPreview: (state) => state.emailPreview,
};
